import React, { useState, useEffect, useContext } from "react";
import "../../css_files/Master/AddCurrecyMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import getCookie from "../../api";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";

function AddCurrencyMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  currencyupdatedata,
}) {
  const [currencyData, setCurrencyData] = useState({
    CurrencyName: triggerupdate ? currencyupdatedata?.currencyName : "",
    Code: triggerupdate ? currencyupdatedata?.code : "",
    Rate: triggerupdate ? currencyupdatedata?.rate : "",
    Description: triggerupdate ? currencyupdatedata?.description : "",
  });
  const [loading, setloading] = useState(false);
  const [codeMessage, setCodeMessage] = useState("");
  const [nameMessage, setNameMessage] = useState("");
  const { setExpiredSession } = useContext(triggerscroll);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/Currency/UpdateCurrency`;
      axiosInstance
        .post(URL, {
          id: currencyupdatedata.currencyId,
          CurrencyName: currencyData.CurrencyName,
          Code: currencyData.Code,
          Rate: currencyData.Rate,
          Description: currencyData.Description,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(error);
          setloading(false);
        });
    } else {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/Currency`;
      axiosInstance
        .post(URL, currencyData)
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(error);
          setloading(false);
        });
    }
  }
  return (
    <form className="add-currency-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Currency Name{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Currency Name"
          onChange={(e) =>
            setCurrencyData({ ...currencyData, CurrencyName: e.target.value.replace(/[^a-zA-Z\s]/g, "")
              .slice(0, 100) })
          }
          value={currencyData.CurrencyName}
          required
        />
        <span style={{ color: "red" }}>{nameMessage}</span>
      </blockquote>
      <blockquote>
        <label>
          Currency Code{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Currency Code"
          onChange={(e) =>
            setCurrencyData({ ...currencyData, Code: e.target.value.replace(/[^A-Za-z]/g, "")
              .toUpperCase()
              .slice(0, 3) })
          }
          value={currencyData.Code}
          required
        />
        <span style={{ color: "red" }}>{codeMessage}</span>
      </blockquote>
      <blockquote>
        <label>
          Rate{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Currency Rate"
          onChange={(e) =>
            setCurrencyData({ ...currencyData, Rate: e.target.value })
          }
          value={currencyData.Rate}
          onInput={(e) => {
            e.target.value = e.target.value
              .replace(/[^0-9.]/g, "")
              .replace(/(\..*)\./g, "$1")
              .replace(/^(\d*\.\d{2}).*$/, "$1");
          }}
          required
        />
      </blockquote>
      <blockquote>
        <label>Description</label>
        <textarea
          rows={5}
          placeholder="Enter Currency Description (Maximum 400 Characters)"
          onChange={(e) =>
            setCurrencyData({ ...currencyData, Description: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 400);
          }}
          value={currencyData.Description}
        ></textarea>
      </blockquote>
      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddCurrencyMaster;
